import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    // Add global event listener for iframe:open modals
    this.handleModalClick = this.handleModalClick.bind(this);
    document.addEventListener('click', this.handleModalClick, true);
  }

  disconnect() {
    document.removeEventListener('click', this.handleModalClick, true);
  }

  handleModalClick(event) {
    const link = event.target.closest('a[rel~="iframe:open"]');
    if (!link) return;
    
    event.preventDefault();
    event.stopImmediatePropagation();
    
    const url = link.getAttribute('href');
    
    // Create spinner HTML
    const spinnerHtml = `
      <div class="modal-loading-wrapper">
        <div class="modal-spinner show">
          <div class="rect1"></div>
          <div class="rect2"></div>
          <div class="rect3"></div>
          <div class="rect4"></div>
        </div>
      </div>
    `;
    
    // Create modal with spinner and iframe
    const modalDiv = document.createElement('div');
    modalDiv.className = 'modal';
    
    const iframe = document.createElement('iframe');
    iframe.src = url;
    iframe.style.display = 'none';
    iframe.style.border = 'none';
    
    const spinnerWrapper = document.createElement('div');
    spinnerWrapper.innerHTML = spinnerHtml;
    
    modalDiv.appendChild(spinnerWrapper.firstElementChild);
    modalDiv.appendChild(iframe);
    
    document.body.appendChild(modalDiv);
    
    // Initialize jQuery modal
    if (typeof $ !== 'undefined' && $.fn.modal) {
      $(modalDiv).modal();
    }
    
    // When iframe loads, resize it, remove spinner, and show iframe
    iframe.addEventListener('load', () => {
      if (!modalDiv.isConnected) return;
      
      // Remove spinner and show iframe first
      const spinner = modalDiv.querySelector('.modal-loading-wrapper');
      if (spinner) spinner.remove();
      iframe.style.display = 'block';
      
      // Try to resize iframe (same logic as EB.Utils.resizeIframe)
      try {
        const iframeHeight = iframe.contentWindow.document.body.scrollHeight + 10;
        iframe.height = iframeHeight + 'px';
      } catch (e) {
        // If can't access contentWindow (cross-origin), use a default height
        iframe.height = '600px';
      }
    });
  }
}
